module.exports = __webpack_public_path__ + "static/media/airra.366580d5.png";